import '@babel/polyfill';
import axios from 'axios';
import IdleVue from 'idle-vue';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import VuejsDialog from 'vuejs-dialog';
import VueLogger from 'vuejs-logger';
import VueMoment from 'vue-moment';
import VueTimers from 'vue-timers';
import VueToasted from 'vue-toasted';
import {
  Drag,
  Drop
} from 'vue-drag-drop';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';

import eventbus from './eventbus';

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

const vueLoggerOptions = {
  // optional : defaults to true if not specified
  isEnabled: true,
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: false,
  // optional : defaults to false if not specified
  showLogLevel: true,
  // optional : defaults to false if not specified
  showMethodName: true,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: true
};

const vueToastedOptions = {
  duration: 5000,
  iconPack: 'fontawesome',
  position: 'bottom-right'
};

const idleViewOptions = {
  eventEmitter: eventbus,
  store
};

Vue.component('drag', Drag);
Vue.component('drop', Drop);
Vue.use(IdleVue, idleViewOptions);
Vue.use(VueCookie);
Vue.use(VuejsDialog);
Vue.use(VueLogger, vueLoggerOptions);
Vue.use(VueMoment);
Vue.use(VueTimers);
Vue.use(VueToasted, vueToastedOptions);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
